<div class="copo-container">
	<ng-template #loadingOrError>
		<copo-loading-spinner *ngIf="isLoading"></copo-loading-spinner>
	</ng-template>
	<div class="copo-section copo-error-label" *ngIf="!isSoldToAvailable">
		<span translate>fastlane.soldto.shipto.error</span>
	</div>
	<ng-container *ngIf="!isLoading && isSoldToAvailable; else loadingOrError">
		<div class="copo-section">
			<div class="copo-section-header">
				<span translate>fastlane.request.title</span>
			</div>
			<div class="copo-section-body copo-grid">
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
						<mat-form-field class="copo-form-field">
							<mat-label translate>fastlane.header.wizard.customer-request-name</mat-label>
							<input
								#coNbrField
								type="text"
								matInput
								spellcheck="false"
								autocomplete="off"
								maxlength="120"
								required
								[formControl]="form.getFormCustomerRequestName()"
								(change)="requestNameSpaceHandle()"
							>
							<mat-icon color="accent" class="icon-size" svgIcon="copo_pencil" matSuffix>
							</mat-icon>
							<mat-hint align="end">{{coNbrField.value.length || 0}}/120</mat-hint>
							<mat-error *ngIf="form.getFormCustomerRequestName().hasError('required')">
								<span translate>fastlane.header.customer-request-name.error.mandatory</span>
							</mat-error>
						</mat-form-field>
					</div>
					<div class="copo-grid-row-column">
							<!-- Sold-To -->
							<mat-form-field class="copo-form-field">
								<mat-label translate>fastlane.wizard.soldto.name</mat-label>
								<mat-select required [formControl]="form.getFormSoldTo()" (selectionChange)="changeSoldToValues()" [compareWith]="compareWithFn">
									<mat-option
										*ngFor="let soldTo of soldToBocList|copoSortOptions:false:configForBoc"
										[value]="soldTo.businessId"
										[matTooltip]="soldTo.name +' / '+ soldTo.city"
									>
										{{soldTo.name}}&nbsp;/&nbsp;{{soldTo.city}}
									</mat-option>
								</mat-select>
								<mat-error *ngIf="form.getFormSoldTo().hasError('required')
								|| form.getFormSoldTo().invalid
								|| form.getFormSoldTo().touched">
									<span translate>fastlane.wizard.header.customer</span>
								</mat-error>
							</mat-form-field>
						</div>
					<div class="copo-grid-row-column"></div>
				</div>
				<div class="copo-grid-row">
					<div class="copo-header-product-infos-label" translate>fastlane.delivery.infos.title</div>
				</div>
				<div class="copo-grid-row-ship-to-block">
					<div class="copo-grid-row-column">
						<!-- ShipTo -->
						<mat-form-field class="copo-form-field">
							<mat-label translate>fastlane.wizard.delivery.address</mat-label>
							<mat-select [formControl]="form.getFormShipTo()" required (selectionChange)="changeBocValues()" #shipToField>
								<mat-option value="LATER"
									[matTooltip]="'fastlane.wizard.decide.later' | translate">
									<div class="copo-fastlane-ship-to-name" translate>fastlane.wizard.decide.later</div>
								</mat-option>
								<mat-option value="CUSTOM"
									[matTooltip]="'fastlane.wizard.custom.destination' | translate">
									<div class="copo-fastlane-ship-to-name" translate>fastlane.wizard.custom.destination</div>
								</mat-option>
								<mat-option *ngFor="let shipTo of getShipToList() |copoSortOptions:false:configForBoc" [value]="shipTo.businessId">
									<div class="copo-fastlane-ship-to-name" [matTooltip]="shipTo.name +' / '+ shipTo.city">{{shipTo.name}}&nbsp;/&nbsp;{{shipTo.city}}</div>
									<div class="copo-fastlane-ship-to-address" *ngIf="shipToField.panelOpen" [matTooltip]="shipTo.address +' '+ (shipTo.postalCode ? shipTo.postalCode : '') + ' ' + shipTo.city + ' (' + shipTo.country + ')'">
										{{shipTo.address}} {{shipTo.postalCode}} {{shipTo.city}} ({{shipTo.country}})
									</div>
								</mat-option>
							</mat-select>
							<mat-error *ngIf="form.getFormShipTo().hasError('required')">
								<span translate>fastlane.delivery.address</span>
							</mat-error>
						</mat-form-field>
					</div>
					<div *ngIf="form.getFormShipTo().value === 'CUSTOM'" class="copo-grid-row-column box">
						<span class="card-content-label" translate>fastlane.wizard.custom.destination</span>
						<div class="copo-grid-row">
							<div class="copo-grid-row-column-ship-to-block">
								<mat-form-field class="copo-form-field">
									<mat-label translate>fastlane.wizard.shipto.name</mat-label>
									<input
									type="text"
									matInput
									spellcheck="false"
									autocomplete="off"
									maxlength="150"
									required
									[formControl]="form.getFormShipToCustom()"
									>
									<mat-icon color="accent" class="icon-size" svgIcon="copo_pencil" matSuffix>
									</mat-icon>
									<mat-error *ngIf="form.getFormShipToCustom().hasError('required')">
										<span translate>fastlane.delivery.address</span>
									</mat-error>
								</mat-form-field>
							</div>
							<div class="copo-grid-row-column-ship-to-block">
								<mat-form-field class="copo-form-field">
									<mat-label translate>fastlane.wizard.custom.destination.contact.person</mat-label>
									<input
									type="text"
									matInput
									spellcheck="false"
									autocomplete="off"
									maxlength="50"
									required
									[formControl]="form.getFormShipToPerson()"
									>
									<mat-icon color="accent" class="icon-size" svgIcon="copo_pencil" matSuffix>
									</mat-icon>
									<mat-error *ngIf="form.getFormShipToPerson().hasError('required')">
										<span translate>fastlane.wizard.contact.person.mandatory</span>
									</mat-error>
								</mat-form-field>
							</div>
						</div>
						<div class="copo-grid-row">
							<div class="copo-grid-row-column-empty"></div>
							<div class="copo-grid-row-column-ship-to-block">
								<mat-form-field class="copo-form-field">
									<mat-label translate>fastlane.wizard.contact.phone.number</mat-label>
									<input
									type="text"
									matInput
									spellcheck="false"
									autocomplete="off"
									maxlength="50"
									required
									[formControl]="form.getFormShipToContact()">
									<mat-icon color="accent" class="icon-size" svgIcon="copo_pencil" matSuffix>
									</mat-icon>
									<mat-error *ngIf="form.getFormShipToContact().hasError('required')">
										<span translate>fastlane.wizard.phone.number.mandatory</span>
									</mat-error>
								</mat-form-field>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="copo-section-header">
					<span translate>fastlane.info.request.details</span>
			</div>
			<div class="copo-section-body copo-grid">
			<div class="copo-grid-row">
				<div class="copo-form-container">
					<div class="copo-grid-row-file-upload copo-grid-row-stretch">
						<div class="copo-grid-row-2-columns">
							<div class="copo-label copo-outline-label" translate><span class=""></span> &nbsp;</div>
							<mat-form-field class="copo-form-field outline-comment" appearance="outline">
								<mat-label>Description</mat-label>
								<textarea rows="4" cdkTextareaAutosize matInput maxlength="255"
									[formControl]="form.getFormDescription()" value="form.getFormDescription().value">
									</textarea>
							</mat-form-field>
						</div>
							<div class="copo-grid-row-2-columns">
							<div class="copo-label copo-outline-label" translate>claim.attach.several.documents<span
									class="asterick"></span></div>
							<copo-file-upload class="file-upload" #attachmentDiv [files]="files()" [fileErrors]="fileErrors()"
								[dragAndDropLabel]="('drag.and.drop.files' | translate)" [orLabel]="('upload.or' | translate)"
								[browseFilesLabel]="('browse.files' | translate)"
								[fileUploadNote]="('attachment.limit.description' | translate)"
								(filesAdded)="addAttachments($event)" (fileRemoved)="removeAttachmentEvent($event)">
							</copo-file-upload>
						</div>
					</div>
				</div>
			</div>
		</div>
			<div class="copo-section-header">
				<span translate>fastlane.info.commercial.data</span>
			</div>
			<div class="copo-section-body copo-grid">
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
				<mat-form-field class="copo-form-field">
					<mat-label translate>fastlane.wizard.currency</mat-label>
					<mat-select [formControl]="form.getFormCurrency()" >
						<mat-option *ngFor="let currency of this.getCurrencyList()|copoSortOptions:false:configForCurrency" [value]="currency.code">
							{{currency.code}} - {{currency.description}}
						</mat-option>
					</mat-select>
				</mat-form-field>
					</div>
					<div class="copo-grid-row-column"></div>
					<div class="copo-grid-row-column"></div>
				</div>
		</div>
	</div>
	</ng-container>
</div>